import { lazy } from 'react';

import { Route, Routes } from 'react-router-dom';

import { useFeatureFlag } from '@packages/platform/feature-flags/use-feature-flag';

const AllowListPage = lazy(
  () => import('./allow-list/pages/allow-list-requirements.page'),
);

const ContactConciergePage = lazy(
  () => import('./contact-concierge/pages/contact-concierge.page'),
);

const ContactConciergeSuccessPage = lazy(
  () => import('./contact-concierge/pages/contact-concierge-success.page'),
);

const DownloadsPage = lazy(() => import('./downloads/downloads.page'));

const ZoominPage = lazy(() => import('./zoomin/zoomin.page'));

export const ResourceCenterRoutes = () => {
  const [featureFlag] = useFeatureFlag('ZOOMIN');

  return (
    <Routes>
      <Route path="allow-list" element={<AllowListPage />} />
      <Route path="downloads" element={<DownloadsPage />} />
      <Route path="contact-concierge" element={<ContactConciergePage />} />
      <Route
        path="contact-concierge/success"
        element={<ContactConciergeSuccessPage />}
      />
      {featureFlag && <Route path="zoomin" element={<ZoominPage />} />}
    </Routes>
  );
};
